import { createSelector } from 'reselect';

const FREE = ['free'];
const getLanguage = (state) => state?.config?.language ?? {};
const getMbox = (state) => state?.config?.mbox;
const getAppEnt = (state) => {
    const el = state?.userinfo?.entitlements;
    if (!el || el?.length === 0) {
        return FREE;
    }

    return el;
};

export const getVideoPlayerState = createSelector(
    [getLanguage, getMbox, getAppEnt],
    (language, mbox, appEntitlements) => {
        return {
            language,
            mbox,
            entitlement: appEntitlements
        };
    }
);
